import type React from "react";

import {
  Pagination as DesignSystemPagination,
  type PaginationProps as DesignSystemPaginationProps,
} from "@/design-system/Pagination";
import { useTranslation } from "@/translations";

export type PaginationProps = Omit<DesignSystemPaginationProps, "previousLabel" | "nextLabel">;

export function Pagination(props: PaginationProps): React.ReactNode {
  const { t } = useTranslation();

  return (
    <DesignSystemPagination
      {...props}
      previousLabel={t("common.action.previous")}
      nextLabel={t("common.action.next")}
    />
  );
}
